import { render, staticRenderFns } from "./Option.vue?vue&type=template&id=3dddec25&"
import script from "./Option.vue?vue&type=script&lang=js&"
export * from "./Option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/boligvelger-v4/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dddec25')) {
      api.createRecord('3dddec25', component.options)
    } else {
      api.reload('3dddec25', component.options)
    }
    module.hot.accept("./Option.vue?vue&type=template&id=3dddec25&", function () {
      api.rerender('3dddec25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Option.vue"
export default component.exports